module.exports = __webpack_public_path__ + "static/c10-8760fc66b92446e8022b7d8cbd9fc374.jpg";